import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import Loader from "@/components/ui/Loader";
import {
  getCoreRowModel,
  useReactTable,
  type ColumnDef,
} from "@tanstack/react-table";
import Table from "components/ui/my-data-table";
import MyRefetchButton from "components/ui/MyRefetchButton";
import useSWR from "swr";
import { columns } from "./data-table-column";

export const DraftsTab = () => {
  const { data = [], isLoading, isValidating, mutate } = useSWR([
    "/spine-drafts",
  ]);

  const table = useReactTable({
    data,
    columns: columns as ColumnDef<Record<string, unknown>, unknown>[],
    enableRowSelection: false,
    getRowId: (row) => String((row as { id: string }).id),
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className="flex flex-col h-[calc(100vh-150px)]">
      <div className="flex-shrink-0 mb-2">
        <MyRefetchButton onClick={() => mutate()} />
      </div>
      {isLoading || isValidating ? (
        <Loader>Loading drafts…</Loader>
      ) : !data?.length ? (
        <div className="text-muted-foreground text-sm">
          No drafts in the review queue.
        </div>
      ) : (
        <div className="flex-1 min-h-0">
          <Card className="h-full flex flex-col">
            <CardContent className="flex-1 overflow-hidden pl-4 pr-0 pb-0">
              <div className="h-full overflow-auto">
                <Table table={table} />
              </div>
            </CardContent>
          </Card>
        </div>
      )}
    </div>
  );
};
